"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetCardVideo = AssetCardVideo;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Api = __importStar(require("@src/api"));
const elements_1 = require("@src/components/elements");
const use_asset_library_notifications_1 = require("@src/components/modules/AssetLibrary/use-asset-library-notifications");
const react_intl_1 = require("react-intl");
const get_mux_video_thumbnail_url_1 = require("@src/shared/get-mux-video-thumbnail-url");
const AssetCardVideoThumbnail = styled_components_1.default.img `
	object-fit: contain;
	height: 100%;
	width: 100%;
`;
const ProcessingMessageContainer = styled_components_1.default.div `
	background-color: white;
	border-radius: 8px 8px 0 0;
	gap: 0.5rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
`;
function AssetCardVideo({ asset, setVideoAssetIsProcessed, deleteAssetLocally }) {
    const { showGeneralErrorNotification, showVideoProcessingFailedNotification } = (0, use_asset_library_notifications_1.useAssetLibraryNotifications)();
    const waitForVideoToBeProcessedAndUpdateAsset = async () => {
        try {
            await Api.Asset.waitForVideoToBeProcessed(asset.muxAssetId);
            setVideoAssetIsProcessed();
        }
        catch (err) {
            if (err === null || err === void 0 ? void 0 : err.response.data.error.videoProcessingFailed) {
                deleteAssetLocally();
                showVideoProcessingFailedNotification(asset.filename);
            }
            else {
                showGeneralErrorNotification();
            }
        }
    };
    react_1.default.useEffect(() => {
        if (asset.isProcessing) {
            waitForVideoToBeProcessedAndUpdateAsset();
        }
    }, []);
    if (asset.isProcessing) {
        return ((0, jsx_runtime_1.jsxs)(ProcessingMessageContainer, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "assets.video_is_processing" }), (0, jsx_runtime_1.jsx)(elements_1.Spinner, {})] }));
    }
    return ((0, jsx_runtime_1.jsx)(AssetCardVideoThumbnail, { src: (0, get_mux_video_thumbnail_url_1.getMuxVideoThumbnailUrl)({ muxPublicPlaybackId: asset.muxPublicPlaybackId, width: 400 }), alt: "video-asset-thumbnail" }));
}
